import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { JwtHelperService, JwtInterceptor } from '@auth0/angular-jwt';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromAuth from '../../auth/reducers';
import * as auth from './../../auth/actions/auth.actions';
import { AuthService } from '../../auth/services/auth.service';
var omitPredicate = function (model) {
    return model.url.endsWith('auth/login')
        || model.url.endsWith('auth/token')
        || model.url.endsWith('/settings')
        || model.url.endsWith('/translations');
};
var ɵ0 = omitPredicate;
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor(store, router, injector) {
        var _this = this;
        this.store = store;
        this.router = router;
        this.injector = injector;
        this.authenticating = false;
        this.done$ = new Subject();
        this.isLoggedIn = new BehaviorSubject(false);
        store.pipe(select(fromAuth.getLoggedIn)).subscribe(this.isLoggedIn);
        store.pipe(select(fromAuth.getRefreshtoken)).subscribe(function (token) { return _this.refreshToken = token; });
        store.pipe(select(fromAuth.getToken)).subscribe(function (token) { return _this.token = token; });
        this.done$.subscribe(function () { return _this.authenticating = false; });
    }
    Object.defineProperty(AuthInterceptor.prototype, "authentication", {
        get: function () {
            if (!this._authSvc)
                this._authSvc = this.injector.get(AuthService);
            return this._authSvc;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthInterceptor.prototype, "jwtHelper", {
        get: function () {
            if (!this._jwtHelper)
                this._jwtHelper = this.injector.get(JwtHelperService);
            return this._jwtHelper;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthInterceptor.prototype, "jwtInterceptor", {
        get: function () {
            if (!this._jwtInterceptor)
                this._jwtInterceptor = this.injector.get(JwtInterceptor);
            return this._jwtInterceptor;
        },
        enumerable: true,
        configurable: true
    });
    AuthInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        var authHeader = request.headers.get('authorization');
        if (authHeader && !omitPredicate(request)) {
            var currentTokenExpirationDate = authHeader
                ? this.jwtHelper.getTokenExpirationDate(authHeader.split('JWT ')[1])
                : null;
            var currentDate = new Date();
            currentDate.setMinutes(currentDate.getMinutes() + 1);
            if (!!currentTokenExpirationDate && (currentTokenExpirationDate <= currentDate)) {
                return this.useRefreshToken(request, next);
            }
            else {
                request = request.clone({
                    setHeaders: {
                        'Authorization': "JWT " + this.token,
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache',
                        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
                    }
                });
                return next.handle(request)
                    .pipe(catchError(function (e) {
                    if (_this.isLoggedIn.getValue() && e.status === 401)
                        _this.store.dispatch(new auth.Logout());
                    return throwError(e);
                }));
            }
        }
        else {
            return next.handle(request)
                .pipe(catchError(function (e) {
                if (_this.isLoggedIn.getValue() && e.status === 401)
                    _this.store.dispatch(new auth.Logout());
                return throwError(e);
            }));
        }
    };
    AuthInterceptor.prototype.useRefreshToken = function (request, next) {
        var _this = this;
        if (this.authenticating) {
            return this.done$
                .pipe(take(1), filter(function (success) { return !!success; }), switchMap(function (_) {
                request = request.clone({
                    setHeaders: {
                        'Authorization': "JWT " + _this.token,
                        'Cache-Control': 'no-cache',
                        'Pragma': 'no-cache',
                        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
                    }
                });
                return next.handle(request);
            }));
        }
        this.authenticating = true;
        return this.authentication.refreshToken(this.refreshToken)
            .pipe(switchMap(function (data) {
            _this.token = data && data.token;
            _this.done$.next(true);
            request = request.clone({
                setHeaders: {
                    'Authorization': "JWT " + _this.token,
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
                }
            });
            return next.handle(request);
        }), catchError(function (e) {
            if (_this.isLoggedIn.getValue() && e.status === 401 && e.url.indexOf('token') !== -1)
                _this.store.dispatch(new auth.Logout());
            _this.done$.next(false);
            return throwError(e);
        }));
    };
    return AuthInterceptor;
}());
export { AuthInterceptor };
export { ɵ0 };
